import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

import {accountingDocumentFormValuesSchema} from '../../../types';

export const createInvoiceOrDraftSchema = accountingDocumentFormValuesSchema
  .extend({
    note: z.string().nullish(),
  })
  .superRefine((data, ctx) => {
    if (!data.submitType || data.submitType === 'CREATE_DRAFT') {
      return;
    }

    if (isNil(data.customer)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['customer'],
      });
    }

    if (!data.dateOfTaxableSupply || data.dateOfTaxableSupply.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['dateOfTaxableSupply'],
      });
    }

    if (!data.dueDate || data.dueDate.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['dueDate'],
      });
    }

    if (isNil(data.dueSinceIssueDateInDays)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['dueSinceIssueDateInDays'],
      });
    }

    if (!data.issueDate || data.issueDate.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['issueDate'],
      });
    }

    if (!data.documentSeriesId || data.documentSeriesId.trim() === '') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['documentSeriesId'],
      });
    }

    if (
      data.paymentInfo?.paymentMethod === 'BANK_TRANSFER' &&
      (!data.paymentInfo.bankAccount || data.paymentInfo.bankAccount.trim() === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['paymentInfo', 'bankAccount'],
      });
    }

    if (data.invoiceItems) {
      data.invoiceItems.forEach((item, index) => {
        if (!item.pricePerUnit || item.pricePerUnit.trim() === '') {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
            path: ['invoiceItems', index, 'pricePerUnit'],
          });
        }

        if (!item.quantity || item.quantity.trim() === '') {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
            path: ['invoiceItems', index, 'quantity'],
          });
        }

        if (!item.vatType) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
            path: ['invoiceItems', index, 'vatType'],
          });
        }

        if (!item.description || item.description.trim() === '') {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: i18n.t('general.validations.fieldIsRequired'),
            path: ['invoiceItems', index, 'description'],
          });
        }
      });
    }

    if (data.isExchangeRateRatioEnabled) {
      if (!data.exchangeRateRatio?.amount) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18n.t('general.notifications.ratioAmountError'),
          path: ['exchangeRateRatio', 'amount'],
        });
      }
      if (!data.exchangeRateRatio?.currency || data.exchangeRateRatio.currency?.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18n.t('general.validations.fieldIsRequired'),
          path: ['exchangeRateRatio', 'currency'],
        });
      }
      if (isNil(data.exchangeRateRatio?.ratio)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18n.t('general.validations.fieldIsRequired'),
          path: ['exchangeRateRatio', 'ratio'],
        });
      }
    }
  });
